/* eslint-disable react/jsx-props-no-spreading */

const TradingComapreSVGIcon = () => {
  return (
    (<svg
      width="30px"
      height="30px"
      viewBox="0 0 30 30"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      data-palette="TradingComapreSVGIcon">
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="ICONS" transform="translate(-118.000000, -170.000000)">
          <g id="compare" transform="translate(118.000000, 170.000000)">
            <rect id="Rectangle" x="0" y="0" width="30" height="30" />
            <g
              transform="translate(3.000000, 5.000000)"
              stroke="var(--main-text-secondary)"
            >
              <path
                d="M17.9347826,15.7608696 C17.9347826,17.5619565 17.9347826,20.1086957 21.1956522,20.1086957 C24.4565217,20.1086957 24.4565217,17.5619565 24.4565217,15.7608696"
                id="Path"
              />
              <polygon
                id="Path"
                strokeLinejoin="round"
                points="21.1956522 10.326087 17.9347826 15.7608696 24.4565217 15.7608696"
              />
              <path
                d="M0.543478261,15.7608696 C0.543478261,17.5619565 0.543478261,20.1086957 3.80434783,20.1086957 C7.06521739,20.1086957 7.06521739,17.5619565 7.06521739,15.7608696"
                id="Path"
              />
              <polygon
                id="Path"
                strokeLinejoin="round"
                points="3.80434783 10.326087 0.543478261 15.7608696 7.06521739 15.7608696"
              />
              <path
                d="M3.80434783,10.326087 L10.326087,10.326087 M21.1956522,10.326087 L14.673913,10.326087"
                id="Shape"
              />
              <circle id="Oval" cx="12.5" cy="10.326087" r="2.17391304" />
              <line x1="12.5" y1="4.89130435" x2="12.5" y2="8.15217391" id="Path" />
              <rect
                id="Rectangle"
                x="11.4130435"
                y="0.543478261"
                width="2.17391304"
                height="4.34782609"
                rx="1"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

const TradingIndicatorSVGIcon = () => {
  return (
    (<svg
      width="30px"
      height="30px"
      viewBox="0 0 30 30"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      data-palette="TradingIndicatorSVGIcon">
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="ICONS" transform="translate(-204.000000, -91.000000)">
          <g id="indicator" transform="translate(204.000000, 91.000000)">
            <rect id="Rectangle" x="0" y="0" width="30" height="30" />
            <g
              transform="translate(3.000000, 10.000000)"
              fill="var(--main-text-secondary)"
              fillRule="nonzero"
              id="Path"
            >
              <path d="M1.71428571,9.37942857 L7.02857143,4.06514286 C7.43728691,3.65505655 7.99244747,3.42455688 8.57142857,3.42455688 C9.15040968,3.42455688 9.70557023,3.65505655 10.1142857,4.06514286 L13.0777143,7.02857143 C13.7007479,7.65290943 14.546546,8.00376873 15.4285714,8.00376873 C16.3105968,8.00376873 17.156395,7.65290943 17.7794286,7.02857143 L23.0937143,1.71428571 L22.2857143,0.906285714 L16.9714286,6.22057143 C16.5627131,6.63065773 16.0075525,6.8611574 15.4285714,6.8611574 C14.8495903,6.8611574 14.2944298,6.63065773 13.8857143,6.22057143 L10.9222857,3.25714286 C10.2992521,2.63280486 9.45345396,2.28194556 8.57142857,2.28194556 C7.68940318,2.28194556 6.84360502,2.63280486 6.22057143,3.25714286 L0.906285714,8.57142857 L1.71428571,9.37942857 Z" />
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

const DisplayOrdersSVGIcon = () => {
  return (
    (<svg
      width="13px"
      height="16px"
      viewBox="0 0 13 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      data-palette="DisplayOrdersSVGIcon">
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="Chart-Redesign-1"
          transform="translate(-415.000000, -177.000000)"
          stroke="var(--main-text-secondary)"
        >
          <g id="Tab-2" transform="translate(0.000000, 167.000000)">
            <g id="file-text" transform="translate(416.000000, 11.000000)">
              <path
                d="M6.875,0 L1.375,0 C0.615608469,0 0,0.615608469 0,1.375 L0,12.375 C0,13.1343915 0.615608469,13.75 1.375,13.75 L9.625,13.75 C10.3843915,13.75 11,13.1343915 11,12.375 L11,4.125 L6.875,0 Z"
                id="Path"
                strokeWidth="0.9"
              />
              <polyline
                id="Path"
                strokeWidth="0.9"
                points="6.875 0 6.875 4.125 11 4.125"
              />
              <line
                x1="8.25"
                y1="7.5625"
                x2="2.75"
                y2="7.5625"
                id="Path"
                strokeWidth="0.8"
              />
              <line
                x1="8.25"
                y1="10.3125"
                x2="2.75"
                y2="10.3125"
                id="Path"
                strokeWidth="0.8"
              />
              <polyline
                id="Path"
                strokeWidth="0.8"
                points="4.125 4.8125 3.4375 4.8125 2.75 4.8125"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

const UndoSVGIcon = () => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 28 28"
      width="28"
      height="28"
      data-palette="UndoSVGIcon">
      <path d="M9 19v-1.5a4.5 4.5 0 0 1 4.5-4.5h6v-1h-6A5.5 5.5 0 0 0 8 17.5V19h1z" />
      <path d="M15.646 16.146l.708.708 4.353-4.354-4.353-4.354-.708.708 3.647 3.646z" />
    </svg>)
  );
};

const RedoSVGIcon = () => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 28 28"
      width="28"
      height="28"
      data-palette="RedoSVGIcon">
      <path d="M20 19v-1.5a5.5 5.5 0 0 0-5.5-5.5h-6v1h6a4.5 4.5 0 0 1 4.5 4.5V19h1z" />
      <path d="M12.354 8.854l-.708-.708L7.293 12.5l4.353 4.354.708-.708L8.707 12.5z" />
    </svg>)
  );
};

const ChartPropertiesSVGIcon = () => {
  return (
    (<svg
      width="30px"
      height="30px"
      viewBox="0 0 30 30"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      data-palette="ChartPropertiesSVGIcon">
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="ICONS" transform="translate(-68.000000, -91.000000)">
          <g id="setting" transform="translate(68.000000, 91.000000)">
            <rect id="Rectangle" x="0" y="0" width="30" height="30" />
            <g
              id="settings"
              transform="translate(4.000000, 4.000000)"
              stroke="var(--main-text-secondary)"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle id="Oval" cx="11" cy="11" r="3" />
              <path
                d="M18.4,14 C18.1276535,14.6170901 18.2583341,15.3378133 18.73,15.82 L18.79,15.88 C19.1655541,16.2551365 19.3765733,16.7641815 19.3765733,17.295 C19.3765733,17.8258185 19.1655541,18.3348635 18.79,18.71 C18.4148635,19.0855541 17.9058185,19.2965733 17.375,19.2965733 C16.8441815,19.2965733 16.3351365,19.0855541 15.96,18.71 L15.9,18.65 C15.4178133,18.1783341 14.6970901,18.0476535 14.08,18.32 C13.4755294,18.5790683 13.0826229,19.1723571 13.08,19.83 L13.08,20 C13.08,21.1045695 12.1845695,22 11.08,22 C9.9754305,22 9.08,21.1045695 9.08,20 L9.08,19.91 C9.0641566,19.2326708 8.63587177,18.6338652 8,18.4 C7.38290993,18.1276535 6.66218673,18.2583341 6.18,18.73 L6.12,18.79 C5.74486349,19.1655541 5.2358185,19.3765733 4.705,19.3765733 C4.1741815,19.3765733 3.66513651,19.1655541 3.29,18.79 C2.91444591,18.4148635 2.70342669,17.9058185 2.70342669,17.375 C2.70342669,16.8441815 2.91444591,16.3351365 3.29,15.96 L3.35,15.9 C3.82166588,15.4178133 3.95234646,14.6970901 3.68,14.08 C3.42093172,13.4755294 2.82764292,13.0826229 2.17,13.08 L2,13.08 C0.8954305,13.08 0,12.1845695 0,11.08 C0,9.9754305 0.8954305,9.08 2,9.08 L2.09,9.08 C2.76732918,9.0641566 3.36613483,8.63587177 3.6,8 C3.87234646,7.38290993 3.74166588,6.66218673 3.27,6.18 L3.21,6.12 C2.83444591,5.74486349 2.62342669,5.2358185 2.62342669,4.705 C2.62342669,4.1741815 2.83444591,3.66513651 3.21,3.29 C3.58513651,2.91444591 4.0941815,2.70342669 4.625,2.70342669 C5.1558185,2.70342669 5.66486349,2.91444591 6.04,3.29 L6.1,3.35 C6.58218673,3.82166588 7.30290993,3.95234646 7.92,3.68 L8,3.68 C8.60447061,3.42093172 8.99737709,2.82764292 9,2.17 L9,2 C9,0.8954305 9.8954305,0 11,0 C12.1045695,0 13,0.8954305 13,2 L13,2.09 C13.0026229,2.74764292 13.3955294,3.34093172 14,3.6 C14.6170901,3.87234646 15.3378133,3.74166588 15.82,3.27 L15.88,3.21 C16.2551365,2.83444591 16.7641815,2.62342669 17.295,2.62342669 C17.8258185,2.62342669 18.3348635,2.83444591 18.71,3.21 C19.0855541,3.58513651 19.2965733,4.0941815 19.2965733,4.625 C19.2965733,5.1558185 19.0855541,5.66486349 18.71,6.04 L18.65,6.1 C18.1783341,6.58218673 18.0476535,7.30290993 18.32,7.92 L18.32,8 C18.5790683,8.60447061 19.1723571,8.99737709 19.83,9 L20,9 C21.1045695,9 22,9.8954305 22,11 C22,12.1045695 21.1045695,13 20,13 L19.91,13 C19.2523571,13.0026229 18.6590683,13.3955294 18.4,14 Z"
                id="Path"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

const ExitFullScreenIcon = props => {
  return (
    (<svg
      width={30}
      height={30}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      data-palette="ExitFullScreenIcon">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.067 10.865 5.885 5.682 5 6.567l5.182 5.183H6.067V13h6.25V6.75h-1.25v4.115Zm-.885 8.068L5 24.114l.885.885 5.183-5.183v4.116h1.25v-6.25h-6.25v1.25h4.114Zm8.068.884v4.116H17v-6.25h6.25v1.25h-4.115l5.183 5.182-.885.885-5.183-5.183Zm0-8.952V6.75H17V13h6.25v-1.25h-4.115l5.182-5.183-.885-.885-5.182 5.183Z"
        fill="#D4D4D4"
      />
    </svg>)
  );
};

const FullScreenSVGIcon = () => {
  return (
    (<svg
      width="30px"
      height="30px"
      viewBox="0 0 30 30"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      data-palette="FullScreenSVGIcon">
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="ICONS" transform="translate(-58.000000, -170.000000)">
          <g id="Full-screen" transform="translate(58.000000, 170.000000)">
            <rect id="Rectangle" x="0" y="0" width="30" height="30" />
            <g
              id="fullscreensvg"
              transform="translate(5.000000, 5.000000)"
              fill="var(--main-text-secondary)"
              fillRule="nonzero"
            >
              <polygon
                id="Path"
                points="18.75 1.25 18.75 6.25 20 6.25 20 0 13.75 0 13.75 1.25"
              />
              <path
                d="M13.5675,7.3175 L19.8175,1.0675 L18.9325,0.1825 L12.6825,6.4325 L13.5675,7.3175 Z M1.25,1.25 L1.25,6.25 L0,6.25 L0,0 L6.25,0 L6.25,1.25 L1.25,1.25 Z"
                id="Shape"
              />
              <path
                d="M6.4325,7.3175 L0.1825,1.0675 L1.0675,0.1825 L7.3175,6.4325 L6.4325,7.3175 Z M18.75,18.75 L18.75,13.75 L20,13.75 L20,20 L13.75,20 L13.75,18.75 L18.75,18.75 Z"
                id="Shape"
              />
              <polygon
                id="Path"
                points="13.5675 12.6825 19.8175 18.9325 18.9325 19.8175 12.6825 13.5675"
              />
              <polygon
                id="Path"
                points="1.25 18.75 1.25 13.75 0 13.75 0 20 6.25 20 6.25 18.75"
              />
              <polygon
                id="Path"
                points="6.4325 12.6825 0.1825 18.9325 1.0675 19.8175 7.3175 13.5675"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

const RotateandOpentoNewTabString = isDarkTheme => {
  return `<svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
  >
    <rect
      width="17"
      height="17"
      x="0.5"
      y="0.5"
      stroke=${isDarkTheme ? '#BABABA' : '#676B72'}
      rx="0.5"
    ></rect>
    <path
      fill=${isDarkTheme ? '#BABABA' : '#676B72'}
      stroke=${isDarkTheme ? '#BABABA' : '#676B72'}
      strokeWidth="0.4"
      d="M4.1 3.593 7.188 6.68l-.508.507L3.593 4.1V6.82h-.718V2.875h3.946v.717zM13.15 13.658l-3.088-3.088.508-.508 3.088 3.088V10.43h.717v3.946h-3.946v-.717z"
    ></path>
  </svg>`;
};

const RotateandRevertToDefaultString = isDarkTheme => {
  return `<svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
  >
    <rect
      width="17"
      height="17"
      x="0.5"
      y="0.5"
      stroke=${isDarkTheme ? '#BABABA' : '#676B72'}
      rx="0.5"
    ></rect>
    <path
      fill=${isDarkTheme ? '#BABABA' : '#676B72'}
      stroke=${isDarkTheme ? '#BABABA' : '#676B72'}
      strokeWidth="0.4"
      d="M6.47 5.963 3.382 2.875l-.507.507L5.963 6.47H3.24v.717h3.947V3.241H6.47zM10.78 11.287l3.088 3.088.507-.507-3.088-3.088h2.722v-.717h-3.947v3.946h.718z"
    ></path>
  </svg>`;
};

const FullScreenSvgString = () => {
  return `<svg
  width="30px"
  height="30px"
  viewBox="0 0 30 30"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
>
  <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g id="ICONS" transform="translate(-58.000000, -170.000000)">
      <g id="Full-screen" transform="translate(58.000000, 170.000000)">
        <rect id="Rectangle" x="0" y="0" width="30" height="30" />
        <g
          id="fullscreensvg"
          transform="translate(5.000000, 5.000000)"
          fill="var(--main-text-secondary)"
          fillRule="nonzero"
        >
          <polygon
            id="Path"
            points="18.75 1.25 18.75 6.25 20 6.25 20 0 13.75 0 13.75 1.25"
          />
          <path
            d="M13.5675,7.3175 L19.8175,1.0675 L18.9325,0.1825 L12.6825,6.4325 L13.5675,7.3175 Z M1.25,1.25 L1.25,6.25 L0,6.25 L0,0 L6.25,0 L6.25,1.25 L1.25,1.25 Z"
            id="Shape"
          />
          <path
            d="M6.4325,7.3175 L0.1825,1.0675 L1.0675,0.1825 L7.3175,6.4325 L6.4325,7.3175 Z M18.75,18.75 L18.75,13.75 L20,13.75 L20,20 L13.75,20 L13.75,18.75 L18.75,18.75 Z"
            id="Shape"
          />
          <polygon
            id="Path"
            points="13.5675 12.6825 19.8175 18.9325 18.9325 19.8175 12.6825 13.5675"
          />
          <polygon
            id="Path"
            points="1.25 18.75 1.25 13.75 0 13.75 0 20 6.25 20 6.25 18.75"
          />
          <polygon
            id="Path"
            points="6.4325 12.6825 0.1825 18.9325 1.0675 19.8175 7.3175 13.5675"
          />
        </g>
      </g>
    </g>
  </g>
</svg>`;
};

const TakeSnapShoptSVGICon = () => {
  return (
    (<svg
      width="30px"
      height="30px"
      viewBox="0 0 30 30"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      data-palette="TakeSnapShoptSVGICon">
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="ICONS" transform="translate(-264.000000, -170.000000)">
          <g id="snapshot" transform="translate(264.000000, 170.000000)">
            <rect id="Rectangle" x="0" y="0" width="30" height="30" />
            <g
              id="camera-(1)"
              transform="translate(4.000000, 6.000000)"
              stroke="var(--main-text-secondary)"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path
                d="M22,16 C22,17.1045695 21.1045695,18 20,18 L2,18 C0.8954305,18 0,17.1045695 0,16 L0,5 C0,3.8954305 0.8954305,3 2,3 L6,3 L8,0 L14,0 L16,3 L20,3 C21.1045695,3 22,3.8954305 22,5 L22,16 Z"
                id="Path"
              />
              <circle id="Oval" cx="11" cy="10" r="4" />
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

const NewTabOpenSVGIcon = () => {
  return (
    (<svg
      width="30px"
      height="30px"
      viewBox="0 0 30 30"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      data-palette="NewTabOpenSVGIcon">
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="ICONS" transform="translate(-184.000000, -170.000000)">
          <g id="New-tab" transform="translate(184.000000, 170.000000)">
            <rect id="Rectangle" x="0" y="0" width="30" height="30" />
            <g
              id="external-link-(1)"
              transform="translate(6.000000, 6.000000)"
              stroke="var(--main-text-secondary)"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path
                d="M15,10 L15,16 C15,17.1045695 14.1045695,18 13,18 L2,18 C0.8954305,18 0,17.1045695 0,16 L0,5 C0,3.8954305 0.8954305,3 2,3 L8,3"
                id="Path"
              />
              <polyline id="Path" points="12 0 18 0 18 6" />
              <line x1="7" y1="11" x2="18" y2="0" id="Path" />
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

const SaveChartIcon = () => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      data-palette="SaveChartIcon">
      <g fill="none">
        <path
          className="dottedCloud-1Vw3lVny"
          stroke="currentColor"
          strokeDasharray="3.5,2.5"
          d="M21.5 21.5h-14a5 5 0 1 1 .42-9.983 7.5 7.5 0 0 1 14.57 2.106 4.002 4.002 0 0 1-.99 7.877z"
        />
      </g>
    </svg>)
  );
};

const ArrowClosed = (
  <span className="arrow-closed" data-palette="ArrowClosed">
    <svg xmlns="http://www.w3.org/2000/svg" width={8} height={5}>
      <path
        d="M3.637 2.829.808 0 0 .808l3.637 3.637L7.273.808 6.465 0z"
        fill="var(--main-text-secondary)"
      />
    </svg>
  </span>
);

const ArrowOpen = (
  <span className="arrow-open" data-palette="ArrowOpen">
    <svg xmlns="http://www.w3.org/2000/svg" width={8} height={5}>
      <path
        d="M3.637 2.829.808 0 0 .808l3.637 3.637L7.273.808 6.465 0z"
        fill="var(--main-text-secondary)"
      />
    </svg>
  </span>
);

const NewTabSvgString = ({ strokeColor }) => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      fill="none"
      viewBox="0 0 14 14"
      data-palette="NewTabSvgString">
      <path
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10.5 7.583v3.5a1.167 1.167 0 0 1-1.167 1.167H2.917a1.167 1.167 0 0 1-1.167-1.167V4.667A1.167 1.167 0 0 1 2.917 3.5h3.5M8.75 1.75h3.5v3.5M5.834 8.167l6.417-6.417"
      />
    </svg>)
  );
};

const DisplayOrdersSVGIconString = ({ strokeColor }) => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      fill="none"
      viewBox="0 0 14 14"
      data-palette="DisplayOrdersSVGIconString">
      <path
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8.167 1.167H3.501a1.167 1.167 0 0 0-1.167 1.166v9.334a1.167 1.167 0 0 0 1.167 1.166h7a1.167 1.167 0 0 0 1.166-1.167v-7z"
      />
      <path
        stroke="var(--main-text-secondary)"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8.166 1.167v3.5h3.5M9.333 7.584H4.666M9.333 9.917H4.666M5.833 5.25H4.666"
      />
    </svg>)
  );
};

export {
  ArrowClosed,
  ArrowOpen,
  ChartPropertiesSVGIcon,
  DisplayOrdersSVGIcon,
  DisplayOrdersSVGIconString,
  ExitFullScreenIcon,
  FullScreenSVGIcon,
  FullScreenSvgString,
  NewTabOpenSVGIcon,
  NewTabSvgString,
  RedoSVGIcon,
  RotateandOpentoNewTabString,
  RotateandRevertToDefaultString,
  SaveChartIcon,
  TakeSnapShoptSVGICon,
  TradingComapreSVGIcon,
  TradingIndicatorSVGIcon,
  UndoSVGIcon,
};
